import routerOptions0 from "/mcc/node_modules/.pnpm/nuxt@3.17.3_@parcel+watcher@2.5.0_@types+node@20.17.19_db0@0.3.2_eslint@8.57.1_ioredis@_9e52384084a119f0ed2f606dbdb42f59/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}